import { marketPeriodHelper } from "app/helpers/marketPeriodHelper";
import { Component } from "react";
import { FormattedMessage } from "react-intl";
import { connect } from "react-redux";
import { BetSlipHelper } from "../../../../../../../../../../../helpers/betSlipHelper";
import type {
  EventMarketType,
  EventType,
} from "../../../../../../../../../../../types/eventType";
import { RunnerTypes } from "../../../../../../../../../../../utils/const";
import RenderOddsComponent from "../RenderOddsComponent/RenderOddsComponent";
import "./CorrectScoreMarketRunnerDetails.scss";
type Props = {
  event: EventType;
  market: EventMarketType;
  marketType: Record<string, any>;
  renderOddsComponent: (...args: Array<any>) => any;
  addBetSlip: (...args: Array<any>) => any;
}; //

class CorrectScoreMarketRunnerDetails extends Component<Props> {
  addBetSlip = (runner: Record<string, any>) => {
    let betSlip = BetSlipHelper.prepareBetSlip(this.props.event, runner);
    this.props.addBetSlip(betSlip);
  };
  isOdd = (length: number) => {
    return length % 2;
  };

  render() {
    const { event, market, marketType } = this.props;
    const emptyCell = (
      <span
        key={`empty-${event.id}-${market.id}`}
        className="correct-score__empty-cell"
      ></span>
    );
    let homeList: JSX.Element[] = [];
    let drawList: JSX.Element[] = [];
    let awayList: JSX.Element[] = [];
    let anyOtherScore: JSX.Element | null = null;

    market.runners.forEach(runner => {
      const emptyCellRunner = (
        <span
          key={`empty-${runner.id}`}
          className="correct-score__empty-cell"
        ></span>
      );

      const runnerEl = marketPeriodHelper.shouldHideRunner(runner) ? (
        emptyCellRunner
      ) : (
        <span
          key={"correct-score" + runner.id}
          onClick={() => {
            this.addBetSlip(runner);
          }}
          className="correct-score__runner"
        >
          <div className="runner__name">
            {marketPeriodHelper.formatRunnerName(runner.name)}
          </div>
          <RenderOddsComponent
            event={event}
            runner={runner}
            marketType={marketType}
          />
        </span>
      );

      if (runner.side === RunnerTypes.HOME) {
        homeList.push(runnerEl);
      }

      if (runner.side === RunnerTypes.DRAW) {
        drawList.push(runnerEl);
      }

      if (runner.side === RunnerTypes.AWAY) {
        awayList.push(runnerEl);
      }

      if (runner.side === RunnerTypes.NA) {
        anyOtherScore = marketPeriodHelper.shouldHideRunner(runner) ? (
          <span
            className="any-other-score any-other-score--empty"
            key={"correct-score" + runner.id}
          ></span>
        ) : (
          <span
            className="any-other-score"
            key={"correct-score" + runner.id}
            onClick={() => {
              this.addBetSlip(runner);
            }}
          >
            <div className="runner__name">
              <FormattedMessage id="any-other-score" tagName="span" />
            </div>
            <RenderOddsComponent
              event={event}
              runner={runner}
              marketType={marketType}
            />
          </span>
        );
      }
    });

    if (this.isOdd(homeList.length)) {
      homeList.push(emptyCell);
    }

    if (this.isOdd(awayList.length)) {
      awayList.push(emptyCell);
    }

    return (
      <div key={`event.participant2-${event.id}`} className={"correct-score"}>
        {event.showHomePlayerAsFirst ? (
          <div className="correct-score__columns">
            <div className="correct-score__columns__home">{homeList}</div>
            <div className="correct-score__columns__draw">{drawList}</div>
            <div className="correct-score__columns__away">{awayList}</div>
          </div>
        ) : (
          <div className="correct-score__columns">
            <div className="correct-score__columns__away">{awayList}</div>
            <div className="correct-score__columns__draw">{drawList}</div>
            <div className="correct-score__columns__home">{homeList}</div>
          </div>
        )}
        <div className="correct-score__na">{anyOtherScore}</div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  translatedSportName: state.sportsSelectionListModel.translatedSportName,
});

function mapDispatchToProps(dispatch) {
  return {
    addBetSlip: (betSlip: EventType) =>
      dispatch.betSlipListModel.addBetSlip(betSlip),
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CorrectScoreMarketRunnerDetails) as any;
